// extracted by mini-css-extract-plugin
export default {"searchListContainer":"IssueDashboardCustomViewPage-module__searchListContainer--zNdz7"};